<script lang="ts">
  import a11yClick from '../../utils/a11y-click';

  export let name: string;
  export let value: string;
  export let group: string | null;
  export let required = false;
  export let disabled = false;
  export let onChange: svelte.JSX.FormEventHandler<HTMLInputElement> = () => {};

  let inputElement: HTMLInputElement;

  $: uniqueId = `radio-input-${value}`;
</script>

<style lang="postcss">
  .radio {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    outline: none;
  }

  .radio:focus-visible input[type='radio'] {
    box-shadow: var(--ubilabs-focus-box-shadow);
  }

  .radio input[type='radio'] {
    vertical-align: text-bottom;
  }

  .radio input[type='radio'] + .labelText {
    margin-top: -0.05em; /* optically vertically center the text */
  }

  .radio input[type='radio']:checked:not(:disabled) + .labelText {
    color: var(--ubilabs-radio-checked-label-color);
  }
</style>

<label class="radio {$$props.class}" for={uniqueId}>
  <input
    id={uniqueId}
    type="radio"
    {name}
    on:click
    on:change={onChange}
    bind:group
    {value}
    {required}
    {disabled}
    bind:this={inputElement}
    on:keypress={event => {
      if (a11yClick(event) && inputElement) {
        inputElement.click();
      }
    }} />

  <span class="labelText">
    <slot />
  </span>
</label>
